<div class="control-line mat-elevation-z8">
    <!-- Market (mat-select with in-panel search) -->
    <div class="filter-actions-line">

        <mat-form-field appearance="outline">
            <mat-label>Market</mat-label>
            <mat-select id="marketSelect" data-testid="marketSelect" [value]="selectedMarketId()"
                (selectionChange)="onMarketSelected($event.value)" (openedChange)="onMarketOpened($event)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #marketFilterInput matInput placeholder="Search markets..." [value]="marketQuery()"
                        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                        (input)="onMarketQuery($event)" />

                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option *ngFor="let m of marketsFiltered(); trackBy: trackByMarketId" [value]="m.id">
                    {{ m.regionName }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Disposal Site</mat-label>
            <mat-select id="disposalSiteSelect" data-testid="disposalSiteSelect" [value]="selectedSiteId()"
                (selectionChange)="onSiteSelected($event.value)" (openedChange)="onSiteOpened($event)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #siteFilterInput matInput placeholder="Search Disposal Site..." [value]="siteQuery()"
                        class="mat-select-search-input" (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()" (input)="onSiteQuery($event)" />

                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option *ngFor="let m of sitesFiltered(); trackBy: trackBySiteId" [value]="m.id">
                    {{ m.siteName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        @if(controlPermissions.updateStatus){
            <button id="updateStatusButton" data-testid="updateStatus" mat-raised-button color="primary"
                [disabled]="isUpdateStatusDisable()" (click)="updateStatus()">
                Update Status
            </button>
        }
    </div>
</div>
<div class="mat-elevation-z8 mar-top-20">
  <mat-card>
    <mat-card-content>
      <div class="gridheight clear-both viewport">
    <table mat-table  class="viewport" [dataSource]="loadProjections" matSort>
        <ng-container matColumnDef="siteName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Name</th>
            <td mat-cell *matCellDef="let r">{{ r.siteName }}</td>
        </ng-container>

        <ng-container matColumnDef="scheduleDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Schedule Date</th>
            <td mat-cell *matCellDef="let r">{{ r.scheduleDate | date:'MM/dd/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="streamName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Stream</th>
            <td mat-cell *matCellDef="let r">{{ r.streamName }}</td>
        </ng-container>

        <ng-container matColumnDef="tankName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tank</th>
            <td mat-cell *matCellDef="let r">{{ r.tankName }}</td>
        </ng-container>

        <ng-container matColumnDef="projected_Quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Projected Quantity</th>
            <td mat-cell *matCellDef="let r">{{ r.projected_Quantity | number }}</td>
        </ng-container>

        <ng-container matColumnDef="haulerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hauler</th>
            <td mat-cell *matCellDef="let r">{{ r.haulerName }}</td>
        </ng-container>

        <ng-container matColumnDef="generatorName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Generator</th>
            <td mat-cell *matCellDef="let r">{{ r.generatorName }}</td>
        </ng-container>

        <ng-container matColumnDef="statusName">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let r" [ngClass]="isCheckboxVisible(r.statusName) ? 'scheduledColumn' : 'scheduledColumnWithoutCheckbox'">
                <mat-checkbox *ngIf="isCheckboxVisible(r.statusName)" color="primary"
                    (change)="selectedStatusRecord(r.id, $event.checked)">
                </mat-checkbox>
                <span> {{ r.statusName }}</span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!--  trackBy added here -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length"
                style="color: red;text-align: center;font-weight: 500;">
                No Projections found.
            </td>
        </tr>
    </table>
     </div>
    </mat-card-content>
  </mat-card>
</div>